import { combineReducers } from 'redux';

import app from './reducers/app';
import webmaster from './reducers/webmaster';
import offers from './reducers/offers';
import news from './reducers/news';
import streams from './reducers/streams';
import statistics from './reducers/statistics';
import tickets from './reducers/tickets';
import finances from './reducers/finances';
import domains from './reducers/domains';
import faq from './reducers/faq';
import dashboard from './reducers/dashboard';
import alerts from './reducers/alerts';
import agencies from './reducers/agencies';
import chat from './reducers/chat';
import referrals from './reducers/referrals';
import slaves from './reducers/slaves';
import contracts from './reducers/contracts';
import promo from './reducers/promo';
import applications from './reducers/applications'
import ttcabinets from './reducers/ttcabinets';
import ttcabinetsRUB from './reducers/ttcabinetsRUB';

export default combineReducers({
  chat,
  agencies,
  alerts,
  app,
  dashboard,
  domains,
  faq,
  finances,
  news,
  offers,
  referrals,
  statistics,
  streams,
  tickets,
  webmaster,
  slaves,
  contracts,
  promo,
  applications,
  ttcabinets,
  ttcabinetsRUB,
});
